"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.search");
require("core-js/modules/es6.function.name");
var _universalH5PageApi = require("@/api/universalH5PageApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Index',
  data: function data() {
    return {
      listLoading: false,
      actName: '',
      dataList: [],
      currentPage: 1,
      dialogVisible: false,
      title: '',
      ruleForm: {
        name: '',
        url: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入页面名称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 字符',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '请输入页面URL',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 字符',
          trigger: 'blur'
        }]
      },
      pageId: '',
      ControlsType: 'add',
      queryData: {
        name: '',
        page: {
          page: 1,
          size: 10
        }
      },
      pagination: {
        currentPage: 1,
        // 默认第几页
        total: 0 // 条数
      }
    };
  },
  created: function created() {
    this.listPageApi();
  },
  methods: {
    del: function del(val) {
      var _this = this;
      this.$confirm('确认删除该活动？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _universalH5PageApi.delAct)({
          id: val
        }).then(function (res) {
          if (res.data) {
            _this.$message({
              type: 'success',
              message: '操作成功'
            });
            _this.listPageApi();
          }
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    copy: function copy(val) {
      var _this2 = this;
      this.$copyText(val).then(function () {
        _this2.$notify.success({
          title: '温馨提示',
          message: '拷贝成功'
        });
      }).catch(function () {
        _this2.$notify.success({
          title: '温馨提示',
          message: '拷贝失败，请手动复制'
        });
      });
    },
    // 添加
    onAdd: function onAdd() {
      this.title = '添加通用H5';
      this.ControlsType = 'add';
      this.dialogVisible = true;
    },
    // 编辑
    onEdit: function onEdit(item) {
      this.title = '编辑通用H5';
      this.ControlsType = 'editor';
      this.dialogVisible = true;
      this.ruleForm.name = item.name;
      this.ruleForm.url = item.openUrl;
      this.pageId = item.pageId;
    },
    // 关闭弹窗
    onClose: function onClose() {
      this.dialogVisible = false;
      this.$refs['ruleForm'].resetFields();
      this.onInit();
    },
    onVerify: function onVerify() {
      if (this.ControlsType === 'add') {
        this.savePageApi();
      } else {
        this.updatePageApi();
      }
    },
    // 初始化
    onInit: function onInit() {
      this.ruleForm = {
        name: '',
        url: ''
      };
    },
    rest: function rest() {
      this.queryData.name = '';
      this.search();
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.listPageApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.listPageApi();
    },
    search: function search() {
      this.queryData.page.page = 1;
      this.listPageApi();
    },
    listPageApi: function () {
      var _listPageApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.listLoading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _universalH5PageApi.listPageApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.dataList = res.data.data;
                this.pagination.total = res.data.total;
                this.listLoading = false;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
              this.listLoading = false;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listPageApi() {
        return _listPageApi2.apply(this, arguments);
      }
      return listPageApi;
    }(),
    savePageApi: function () {
      var _savePageApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                // userId:'',
                name: this.ruleForm.name,
                openUrl: this.ruleForm.url
              };
              _context2.n = 1;
              return (0, _universalH5PageApi.savePageApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
                this.dialogVisible = false;
                this.onInit();
                this.listPageApi();
              } else {
                this.$notify.error({
                  title: '温馨提示',
                  message: '添加失败'
                });
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function savePageApi() {
        return _savePageApi2.apply(this, arguments);
      }
      return savePageApi;
    }(),
    updatePageApi: function () {
      var _updatePageApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                'pageId': this.pageId,
                'name': this.ruleForm.name,
                'openUrl': this.ruleForm.url
              };
              _context3.n = 1;
              return (0, _universalH5PageApi.updatePageApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.dialogVisible = false;
                this.onInit();
                this.listPageApi();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function updatePageApi() {
        return _updatePageApi2.apply(this, arguments);
      }
      return updatePageApi;
    }()
  }
};